import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SendToRetailerPopupComponent } from './send-to-retailer-popup/send-to-retailer-popup.component';

@NgModule({
  declarations: [SendToRetailerPopupComponent],
  imports: [
    CommonModule,
    NgbModule
  ],
  exports: [SendToRetailerPopupComponent]
})
export class SendToRetailerModule { }
